"use strict";

function t(t, r) {
  (null == r || r > t.length) && (r = t.length);

  for (var n = 0, e = new Array(r); n < r; n++) {
    e[n] = t[n];
  }

  return e;
}

function r(r, n) {
  var e;

  if ("undefined" == typeof Symbol || null == r[Symbol.iterator]) {
    if (Array.isArray(r) || (e = function (r, n) {
      if (r) {
        if ("string" == typeof r) return t(r, void 0);
        var e = Object.prototype.toString.call(r).slice(8, -1);
        return "Object" === e && r.constructor && (e = r.constructor.name), "Map" === e || "Set" === e ? Array.from(r) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? t(r, void 0) : void 0;
      }
    }(r)) || n && r && "number" == typeof r.length) {
      e && (r = e);
      var a = 0;
      return function () {
        return a >= r.length ? {
          done: !0
        } : {
          done: !1,
          value: r[a++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  return (e = r[Symbol.iterator]()).next.bind(e);
}

function n(t, n) {
  return void 0 === n && (n = "{$origin}\n{$ttl}\n\n; SOA Record\n{name} {ttl}    IN  SOA {mname}{rname}(\n{serial} ;serial\n{refresh} ;refresh\n{retry} ;retry\n{expire} ;expire\n{minimum} ;minimum ttl\n)\n\n; NS Records\n{ns}\n\n; MX Records\n{mx}\n\n; A Records\n{a}\n\n; AAAA Records\n{aaaa}\n\n; CNAME Records\n{cname}\n\n; PTR Records\n{ptr}\n\n; TXT Records\n{txt}\n\n; SRV Records\n{srv}\n\n; SPF Records\n{spf}\n\n; URI Records\n{uri}\n"), n = function (t, r) {
    var n = "";
    return void 0 !== t && (n += "$ORIGIN " + t), r.replace("{$origin}", n);
  }(t.$origin, n), n = function (t, r) {
    var n = "";
    return void 0 !== t && (n += "$TTL " + t), r.replace("{$ttl}", n);
  }(t.$ttl, n), n = function (t, r) {
    var n = r;
    if (void 0 !== t) for (var e in t.name = t.name || "@", t.ttl = t.ttl || "", t) {
      n = n.replace("{" + e + "}", t[e] + "\t");
    }
    return n;
  }(t.soa, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tNS\t" + s.host + "\n";
    }
    return n.replace("{ns}", e);
  }(t.ns, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tA\t" + s.ip + "\n";
    }
    return n.replace("{a}", e);
  }(t.a, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tAAAA\t" + s.ip + "\n";
    }
    return n.replace("{aaaa}", e);
  }(t.aaaa, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tCNAME\t" + s.alias + "\n";
    }
    return n.replace("{cname}", e);
  }(t.cname, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tMX\t" + s.preference + "\t" + s.host + "\n";
    }
    return n.replace("{mx}", e);
  }(t.mx, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tPTR\t" + s.host + "\n";
    }
    return n.replace("{ptr}", e);
  }(t.ptr, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tTXT\t";
      var o = s.txt;
      "string" == typeof o ? e += '"' + o + '"' : o instanceof Array && (e += o.map(function (t) {
        return '"' + t + '"';
      }).join(" ")), e += "\n";
    }
    return n.replace("{txt}", e);
  }(t.txt, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tSRV\t" + s.priority + "\t", e += s.weight + "\t", e += s.port + "\t", e += s.target + "\n";
    }
    return n.replace("{srv}", e);
  }(t.srv, n), n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tSPF\t" + s.data + "\n";
    }
    return n.replace("{spf}", e);
  }(t.spf, n), (n = function (t, r) {
    r = (r = r.replace("{zone}", t.$origin || !!t.soa && t.soa.name || "")).replace("{datetime}", new Date().toISOString());
    var n = Math.round(Date.now() / 1e3);
    return r.replace("{time}", "" + n);
  }(t, n = function (t, n) {
    var e = "";
    if (t) for (var a, i = r(t); !(a = i()).done;) {
      var s = a.value;
      e += (s.name || "@") + "\t", s.ttl && (e += s.ttl + "\t"), e += "IN\tURI\t" + s.priority + "\t", e += s.weight + "\t", e += '"' + s.target + '"\n';
    }
    return n.replace("{uri}", e);
  }(t.uri, n))).replace(/\n{2,}/gim, "\n\n");
}

function e(t) {
  return function (t) {
    for (var n, e = {}, g = r(t.split("\n")); !(n = g()).done;) {
      var h = n.value;

      if (h && h.trim()) {
        var d = h.toUpperCase();
        /\s+TXT\s+/.test(d) ? (e.txt = e.txt || [], e.txt.push(u(h))) : 0 === d.indexOf("$ORIGIN") ? e.$origin = h.split(/\s+/g)[1] : 0 === d.indexOf("$TTL") ? e.$ttl = parseInt(h.split(/\s+/g)[1], 10) : /\s+SOA\s+/.test(d) ? e.soa = a(h) : /\s+NS\s+/.test(d) ? (e.ns = e.ns || [], e.ns.push(i(h))) : /\s+A\s+/.test(d) ? (e.a = e.a || [], e.a.push(s(h, e.a))) : /\s+AAAA\s+/.test(d) ? (e.aaaa = e.aaaa || [], e.aaaa.push(o(h))) : /\s+CNAME\s+/.test(d) ? (e.cname = e.cname || [], e.cname.push(l(h))) : /\s+MX\s+/.test(d) ? (e.mx = e.mx || [], e.mx.push(p(h))) : /\s+PTR\s+/.test(d) ? (e.ptr = e.ptr || [], e.ptr.push(c(h, e.ptr, e.$origin))) : /\s+SRV\s+/.test(d) ? (e.srv = e.srv || [], e.srv.push(f(h))) : /\s+SPF\s+/.test(d) ? (e.spf = e.spf || [], e.spf.push(m(h))) : /\s+URI\s+/.test(d) && (e.uri = e.uri || [], e.uri.push(v(h)));
      }
    }

    return e;
  }(t = function (t) {
    for (var r = [], n = /\([\s\S]*?\)/gim, e = n.exec(t); null !== e;) {
      var a = e[0].replace(/\s+/gm, " ");
      r.push({
        match: e,
        replacement: a
      }), e = n.exec(t);
    }

    for (var i = t.split(""), s = 0, o = r; s < o.length; s++) {
      var l = o[s],
          p = l.match;
      i.splice(p.index, p[0].length, l.replacement);
    }

    return i.join("").replace(/\(|\)/gim, " ");
  }(t = function (t) {
    return t.replace(/(^|[^\\]);.*/g, function (t, r) {
      return r || "";
    });
  }(t)));
}

function a(t) {
  var r = {},
      n = t.trim().split(/\s+/g),
      e = n.length;
  return r.name = n[0], r.minimum = parseInt(n[e - 1], 10), r.expire = parseInt(n[e - 2], 10), r.retry = parseInt(n[e - 3], 10), r.refresh = parseInt(n[e - 4], 10), r.serial = parseInt(n[e - 5], 10), r.rname = n[e - 6], r.mname = n[e - 7], isNaN(n[1]) || (r.ttl = parseInt(n[1], 10)), r;
}

function i(t) {
  var r = t.trim().split(/\s+/g),
      n = {
    name: r[0],
    host: r[r.length - 1]
  };
  return isNaN(r[1]) || (n.ttl = parseInt(r[1], 10)), n;
}

function s(t, r) {
  var n = t.trim().split(/\s+/g),
      e = t.trim().toUpperCase().split(/\s+/g),
      a = {
    name: n[0],
    ip: n[n.length - 1]
  };
  return 0 === e.lastIndexOf("A") && (a.name = r.length ? r[r.length - 1].name : "@"), isNaN(n[1]) || (a.ttl = parseInt(n[1], 10)), a;
}

function o(t) {
  var r = t.trim().split(/\s+/g),
      n = {
    name: r[0],
    ip: r[r.length - 1]
  };
  return isNaN(r[1]) || (n.ttl = parseInt(r[1], 10)), n;
}

function l(t) {
  var r = t.trim().split(/\s+/g),
      n = {
    name: r[0],
    alias: r[r.length - 1]
  };
  return isNaN(r[1]) || (n.ttl = parseInt(r[1], 10)), n;
}

function p(t) {
  var r = t.trim().split(/\s+/g),
      n = r.length,
      e = {
    name: r[0],
    preference: parseInt(r[n - 2], 10),
    host: r[n - 1]
  };
  return isNaN(r[1]) || (e.ttl = parseInt(r[1], 10)), e;
}

function u(t) {
  var r = t.trim().match(/[^\s"']+|"[^"]*"|'[^']*'/g);
  if (!r) throw new Error("Failure to tokenize TXT record");
  var n,
      e = r.length,
      a = r.indexOf("TXT");

  function i(t) {
    return t.indexOf('"') > -1 && (t = t.split('"')[1]), t;
  }

  n = e - a - 1 > 1 ? [].concat(r.slice(a + 1).map(i)) : i(r[e - 1]);
  var s = {
    name: r[0],
    txt: n
  };
  return isNaN(r[1]) || (s.ttl = parseInt(r[1], 10)), s;
}

function c(t, r, n) {
  var e = t.trim().split(/\s+/g);
  0 === t.trim().toUpperCase().split(/\s+/g).lastIndexOf("PTR") && r[r.length - 1] && e.unshift(r[r.length - 1].name);
  var a = {
    name: e[0],
    fullname: e[0] + "." + n,
    host: e[e.length - 1]
  };
  return isNaN(e[1]) || (a.ttl = parseInt(e[1], 10)), a;
}

function f(t) {
  var r = t.trim().split(/\s+/g),
      n = r.length,
      e = {
    name: r[0],
    target: r[n - 1],
    priority: parseInt(r[n - 4], 10),
    weight: parseInt(r[n - 3], 10),
    port: parseInt(r[n - 2], 10)
  };
  return isNaN(r[1]) || (e.ttl = parseInt(r[1], 10)), e;
}

function m(t) {
  for (var r = t.trim().split(/\s+/g), n = {
    name: r[0],
    data: ""
  }, e = r.length; e-- > 4;) {
    n.data = r[e] + " " + n.data.trim();
  }

  return isNaN(r[1]) || (n.ttl = parseInt(r[1], 10)), n;
}

function v(t) {
  var r = t.trim().split(/\s+/g),
      n = r.length,
      e = {
    name: r[0],
    target: r[n - 1].replace(/"/g, ""),
    priority: parseInt(r[n - 3], 10),
    weight: parseInt(r[n - 2], 10)
  };
  return isNaN(r[1]) || (e.ttl = parseInt(r[1], 10)), e;
}

exports.ZoneFile = function () {
  function t(t) {
    this.jsonZoneFile = "object" == typeof t ? JSON.parse(JSON.stringify(t)) : "string" == typeof t ? e(t) : void 0;
  }

  var r = t.prototype;
  return r.toJSON = function () {
    return this.jsonZoneFile;
  }, r.toString = function () {
    return n(this.toJSON());
  }, t;
}(), exports.makeZoneFile = n, exports.parseZoneFile = e;